import { render, staticRenderFns } from "./car-attribute-details-popup.vue?vue&type=template&id=670ffedc&scoped=true&"
import script from "./car-attribute-details-popup.vue?vue&type=script&lang=js&"
export * from "./car-attribute-details-popup.vue?vue&type=script&lang=js&"
import style0 from "./car-attribute-details-popup.vue?vue&type=style&index=0&id=670ffedc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ffedc",
  null
  
)

export default component.exports